import React from 'react';
import styled from 'styled-components';
import EvolutionIcon from 'components/EvolutionIcon';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

const TooltipContainer = styled.div`
  .rhcTooltipContainer {
    min-width: 350px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    width: 100%;
    margin-bottom: 10px;
    > p {
      color: #abb5be;
      font-family: ${(props) => props.theme.fonts.sfcompact_semibold};
    }
  }
  .priceTooltipLabelsContainer {
    margin-left: auto;
    width: 75%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  padding: 12px;
  min-width: 500px;

  .rhcDate {
    color: #abb5be;
    text-transform: uppercase;
  }
  .priceTooltipLabels {
    text-transform: uppercase;
    white-space: nowrap;
    font-family: ${(props) => props.theme.fonts.sfcompact_semibold};
    text-align: center !important;
    width: 100% !important;
    justify-content: center;
    align-items: center;
  }
`;

const Tooltip = ({
  data = [],
  labels,
  currency
}: {
  data: any[];
  labels: string[];
  currency: string;
}) => (
  <TooltipContainer>
    <div className="priceTooltipLabelsContainer">
      <p className="priceTooltipLabels">{I18n.t('lowPrice')}</p>
      <p className="priceTooltipLabels">{I18n.t('averagePrice')}</p>
      <p className="priceTooltipLabels">{I18n.t('highPrice')}</p>
    </div>
    {data
      .filter(
        (set, index) => set && labels[index] && set.value && set.value.value
      )
      .map((set, index) => (
        <div key={index}>
          <div className="rhcTooltipContainer">
            <p>{`${set.wine_name} ${set.name}`}</p>
            <div className="rhcTooltipValues">
              {Object.keys(set).map(
                (key) =>
                  set[key] &&
                  set[key].value && (
                    <div key={[index, key].join('-')}>
                      <EvolutionIcon icon={set[key].icon} />
                      <p>
                        {set[key].value.toLocaleString('fr-FR', {
                          style: 'currency',
                          currency: get(set, 'value.currency', currency),
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 1
                        })}
                      </p>
                    </div>
                  )
              )}
            </div>
          </div>
          {currency && currency !== set.displayed_currency && (
            <div className="rhcTooltipContainer">
              <div className="rhcTooltipValues">
                <p className="">
                  {set.isLastYear
                    ? set.ly_min_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })
                    : set.min_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })}
                </p>
                <p className="">
                  {set.isLastYear
                    ? set.avg_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })
                    : set.avg_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })}
                </p>
                <p className="">
                  {set.isLastYear
                    ? set.ly_max_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })
                    : set.max_price.toLocaleString('fr-FR', {
                        style: 'currency',
                        currency: set.displayed_currency
                          ? set.displayed_currency
                          : 'EUR',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1
                      })}
                </p>
              </div>
            </div>
          )}
          <div className="rhcTooltipContainer">
            <div className="rhcTooltipValues">
              <p className="">
                {set.isLastYear ? set.ly_min_store : set.min_store}
              </p>
              <p className="" />
              <p className="">
                {set.isLastYear ? set.ly_max_store : set.max_store}
              </p>
            </div>
          </div>
        </div>
      ))}
  </TooltipContainer>
);

export default Tooltip;
